export const IFRAME_ID = "fashion-inspiration-viewer";

export const EXPLORATIONS_API_URL = "/api/v1/explorations/";
export const EXPLORATION_IMAGE_API_URL = "/api/v1/generated-image/";

export enum FashionInspirationIframeEventTypes {
    READY = "fashionInspiration::ready",
    REFRESH_TOKEN = "fashionInspiration::refreshToken",
}

export const STYLE_NODE_TYPE = "Style";
export const PRODUCT_NODE_TYPE = "Product";

export const MERCH_TYPES = [
	"MerchCollectionVersion",
	"MerchProductVersion",
];
export const STYLE_TYPES = ["Style", "Collection", "Category2", "Category1", "Season"];
export const ALLOWED_TYPES = [...STYLE_TYPES, ...MERCH_TYPES];

export const SUPPORTED_TYPES_FOR_NEW_STYLE = ["Collection", "Category2", "Category1", "Season"];
export const SUPPORTED_TYPES_FOR_NEW_PRODUCT = ["MerchCollectionVersion"];

export const SUPPORTED_TABS_FOR_NEW_STYLE = ["AllStyles", "__Print__"];
export const SUPPORTED_TABS_FOR_NEW_PRODUCT = ["Target"];

export const DEFAULT_TAB_ID_FOR_NEW_STYLE = "__Print__";
export const DEFAULT_TAB_ID_FOR_NEW_PRODUCT = "Target";

export const TYPE_WITH_CUSTOM_FORM_FOR_NEW_STYLE = "Collection";
